import { BrokerMedia } from '@insurance/api/requests'
import { Table, TableColumnsType, TableProps } from 'antd'
import { SorterResult } from 'antd/es/table/interface'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getActionColumnMenu } from './tableActions'
import { getTableColumns } from './tableColumns'
import { MediaActions, MediaActionsTypes } from '../MediaActions'

type Props = {
  broker: number
  data?: BrokerMedia[]
  triggerSort: (sorter: SorterResult<BrokerMedia>) => void
  getSortedTableColumns: (
    columns: TableColumnsType<BrokerMedia>
  ) => TableColumnsType<BrokerMedia>
} & TableProps<BrokerMedia>

export const MediaTable = ({
  data,
  broker,
  triggerSort,
  getSortedTableColumns,
  ...props
}: Props) => {
  const { t } = useTranslation()
  const [modal, setModal] = useState<{
    type: MediaActionsTypes
    data: BrokerMedia
  } | null>(null)

  const columns = getSortedTableColumns(
    getTableColumns(getActionColumnMenu(setModal, t), t)
  )

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        onChange={(_, __, sorter) =>
          triggerSort(Array.isArray(sorter) ? sorter[0] : sorter)
        }
        scroll={{ x: 'auto' }}
        {...props}
      />

      {modal && (
        <MediaActions
          broker={broker}
          open
          onCancel={() => setModal(null)}
          onSuccess={() => setModal(null)}
          {...modal}
        />
      )}
    </>
  )
}
